import { withSentryRouting } from '@sentry/react'
import { Redirect, Route, Switch, useRouteMatch } from 'react-router'

import { MonomerErrorBoundary } from '~/components/MonomerErrorBoundary'
import PlatePage from './PlatePage'
import WellRoutes from './well/WellRoutes'

const SentryRoute = withSentryRouting(Route)

export default function PlateRoutes() {
  const match = useRouteMatch()

  return (
    <MonomerErrorBoundary>
      <Switch>
        <SentryRoute
          exact
          path={match.path}
          render={() => <Redirect to='/monitor/dashboard' />}
        />

        <SentryRoute
          exact
          path={`${match.path}/:id`}
          render={({
            match: {
              params: { id },
            },
          }) => <PlatePage id={id} />}
        />

        <SentryRoute
          path={`${match.path}/:id/well`}
          render={({
            match: {
              params: { id },
            },
          }) => <WellRoutes plateID={id} />}
        />
      </Switch>
    </MonomerErrorBoundary>
  )
}
